'use strict';

wbApp.controller('PaymentsCtrl', ['$scope', '$modal', '$q', '$window', '$translate', '$timeout', '$filter', 'semesterSvc',
    'paymentsSvc', 'securitySvc', 'gridSortSvc', 'terminalSvc', 'accountingBookSvc', 'localStorageService', 'tenantSettingSvc',
    function ($scope, $modal, $q, $window, $translate, $timeout, $filter, semesterSvc,
        paymentsSvc, securitySvc, gridSortSvc, terminalSvc, accountingBookSvc, localStorageService, tenantSettingSvc) {

    $scope.semesterDataRange = 1; // 1 - semester, 2 - from to
    $scope.fromDate = moment().subtract(3, 'M').startOf('day').toDate();
    $scope.toDate = moment().startOf('day').toDate();

    if (localStorageService.isSupported) {
        $scope.semesterDataRange = localStorageService.get('semesterDataRange') || 1;
    }

    $scope.customFilter = { invoiceForType: [], terminal: [] };
    $scope.rawPayments = [];
    $scope.payments = [];

    $scope.accountingBooks = accountingBookSvc.getAllAsync();

    function preFilter() {
        $q.all([$scope.rawPayments.$promise, $scope.terminals.$promise, $scope.accountingBooks.$promise]).then(function () {
            var typeIDs = _.values($scope.customFilter.invoiceForType);
            var accountingBookIDs = _.values($scope.customFilter.accountingBooks);
            $scope.payments.length = 0;
            $scope.payments.push.apply($scope.payments,
                _.filter($scope.rawPayments, function (o) {
                    var includesTypeID = true;
                    if (typeIDs.length > 0) {
                        includesTypeID = _.includes(typeIDs, o.typeID);
                    }

                    var includesTerminalID = true;
                    if ($scope.customFilter.terminal.length > 0) {
                        includesTerminalID = _.includes($scope.customFilter.terminal, o.terminalID);
                    }

                    var includesAccountBookID = true;
                    if (accountingBookIDs.length > 0) {
                        includesAccountBookID = _.includes(accountingBookIDs, o.accountingBookID);
                    }

                    return includesTypeID && includesTerminalID && includesAccountBookID;
                })
            );
        });
    }

    $scope.onDataRangeChanged = function () {
        if (localStorageService.isSupported) {
            localStorageService.set('semesterDataRange', $scope.semesterDataRange);
        }

        if ($scope.semesterID != null) {
            loadData();
        }

        if ($scope.gridSettings.gridInstance) {
            if ($scope.semesterDataRange === 1) {
                $scope.gridSettings.gridInstance.columnOption("semesterColumn", "visible", false);
            } else {
                $scope.gridSettings.gridInstance.columnOption("semesterColumn", "visible", true);
            }
        }
    }

    function loadData() {
        if ($scope.semesterDataRange === 1) {
            $scope.rawPayments = paymentsSvc.getAllForSemester($scope.semesterID, true);
        } else {
            $scope.rawPayments = paymentsSvc.getAllForDateRange(
                $scope.fromDate, $scope.toDate, true);
        }
        preFilter();
    }

    $scope.terminals = terminalSvc.getAllAsync();

    $scope.icons = [{
        value: 1,
        label: $translate.instant('TXT_LAB_COURSE')
    }, {
        value: 2,
        label: $translate.instant('TXT_LAB_ACTION_SINGULAR')
    }, {
        value: 3,
        label: $translate.instant('TXT_LAB_KINDERGARTEN')
    }, {
        value: 4,
        label: $translate.instant('TXT_LAB_RESERVATION')
    }];

    $scope.$on('refreshData', function (e, data) {
        if ($scope.semesterID) {
            loadData();
            $scope.selectedPayment = null;
        }
    });

    $scope.$watch('customFilter', function (newValue, oldValue) {
        preFilter();
    }, true);

    $scope.gridSettings = {
        name: 'payments',
        keyExpr: 'paymentID',
        shouldShowColumnChooser: true,
        exportVisibleColumnsOnly: true,
        allowColumnReordering: true,
        columns: [
            {
                name: 'semesterColumn',
                dataField: 'semesterID',
                caption: $translate.instant('TXT_LBL_SEMESTER'),
                dataType: 'string',
                width: '120px',
                calculateCellValue: function (rowData) {
                    return $filter('semester')(rowData.semesterID);
                },
                visible: $scope.semesterDataRange === 2
            },
            {
                dataField: 'studentFullName', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', width: '160px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'studentFullName') }
            },
            {
                dataField: 'operatorFullName', caption: $translate.instant("TXT_LBL_PARENT"), dataType: 'string', width: '160px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'operatorFullName') }
            },
            {
                dataField: 'typeID',
                caption: $translate.instant("TXT_LBL_TYPE"),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('invoiceForType')(rowData.typeID);
                },
                width: '55px'
            },
            { dataField: 'subject', caption: $translate.instant('TXT_LBL_SUBJECT'), dataType: 'string' },
            { dataField: 'notes', caption: $translate.instant('TXT_NOTE'), dataType: 'string' },
            { dataField: 'value', caption: $translate.instant('TXT_LBL_AMOUNT'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            {
                dataField: 'paymentTypeID',
                caption: $translate.instant("TXT_LBL_PAYMENT"),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('paymentType')(rowData.paymentTypeID);
                },
                width: '70px'
            },
            { dataField: 'paymentDate', caption: $translate.instant('TXT_LBL_DATE'), dataType: 'date', width: '90px', sortOrder: 'desc' },
            { dataField: 'invoiceNo', caption: $translate.instant('TXT_LBL_INVOICE_NO'), dataType: 'string', width: '90px', visible: false },
            {
                dataField: 'terminalID',
                caption: $translate.instant('TXT_LBL_TERMINAL'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('terminal')(rowData.terminalID);
                },
                width: '150px',
                visible: false
            },
            {
                dataField: 'email',
                caption: $translate.instant('TXT_LBL_EMAIL'),
                dataType: 'string',
                width: '180px',
                visible: false
            },
            {
                dataField: 'accountingBookID',
                caption: $translate.instant('TXT_LBL_ACCOUNTING_BOOK'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('accountingBook')(rowData.accountingBookID);
                },
                width: '180px',
                visible: false
            },
        ],
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.accountingBookTransactionID || data.paymentTypeID === 4) {
                    e.rowElement.addClass('text-muted');
                }
                if (data.value < 0 && !data.accountingBookTransactionID) {
                    e.rowElement.addClass('text-danger');
                }
            }
        },
        shouldDisableEdit: function (row) { return !!row.accountingBookTransactionID || (row.paymentTypeID === 4); },
        customCommands: [{
            text: $translate.instant('TXT_MENU_PRINT_RECEIPT'),
            isVisible: function (row) {
                return row.paymentTypeID === 1 && securitySvc.isInRole('Payment.CashReceipt') && securitySvc.isInRole('Reports');
            },
            callback: function (row) { onPrintReceipt(row.paymentID, 'pdf'); }
        },
        {
            text: $translate.instant('TXT_MENU_PRINT_INVOICE'),
            isVisible: function () { return securitySvc.isInRole('CourseRegistration.PrintInvoice') && securitySvc.isInRole('Reports'); },
            callback: function (row) { onPrintInvoice(row.invoiceID); }
        },
        {
            text: $translate.instant('TXT_MENU_PRINT_SALES_REPORT'),
            isVisible: function () { return securitySvc.isInRole('Payment.SalesReport') && securitySvc.isInRole('Reports'); },
            callback: function (row) { onPrintSalesReport(); }
        },
        {
            text: $translate.instant('TXT_MENU_PRINT_PAYMENT_CONFIRMATION_REPORT'),
            isVisible: function () { return securitySvc.isInRole('Payment.ConfirmationReport') && securitySvc.isInRole('Reports'); },
            callback: function (row) { onPrintConfirmationReport(row.paymentID, 'pdf'); }
        },
        {
            text: $translate.instant('TXT_MENU_EXPORT_RECEIPT_XLS'),
            isVisible: function (row) {
                return row.paymentTypeID === 1 && securitySvc.isInRole('Payment.CashReceipt') && securitySvc.isInRole('Reports');
            },
            callback: function (row) { onPrintReceipt(row.paymentID, 'xls'); }
        },
        {
            text: $translate.instant('TXT_MENU_EXPORT_PAYMENT_CONFIRMATION_REPORT_XLS'),
            isVisible: function () { return securitySvc.isInRole('Payment.ConfirmationReport') && securitySvc.isInRole('Reports'); },
            callback: function (row) { onPrintConfirmationReport(row.paymentID, 'xls'); }
        },
        {
            text: "(" + $translate.instant('TXT_LBL_SUPPORT') + ") " + $translate.instant('TXT_ISSUE_TAX_DOCUMENT_IF_NEEDED'),
            isVisible: function () { return tenantSettingSvc.settings.createTaxDocuments && securitySvc.isInRole('Support'); },
            callback: function (row) { onIssueTaxDocumentIfNeeded(row.paymentID); }
        }]
    }

    function onPrintReceipt(paymentID, format) {
        if (securitySvc.isInRole('Payment.CashReceipt') && securitySvc.isInRole('Reports')) {

            if (format == 'xls') {
                $("#dataDownloadIFrame").remove();
                $("body").append("<iframe id='dataDownloadIFrame' src='/Admin/Report/CashReceipt?PaymentID=" + paymentID + "&format=xls' style='height: 0px;' ></iframe>");
            }
            else {
                $window.open('/Admin/Report/CashReceipt?PaymentID=' + paymentID,
                    '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
            }
        }
    }

    function onPrintInvoice(invoiceID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + invoiceID + '&ReportIDType=1',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    function onPrintConfirmationReport(paymentID, format) {
        if (securitySvc.isInRole('Payment.ConfirmationReport') && securitySvc.isInRole('Reports')) {

            if (format == 'xls') {
                $("#dataDownloadIFrame").remove();
                $("body").append("<iframe id='dataDownloadIFrame' src='/Admin/Report/PaymentConfirmation?PaymentID=" + paymentID + "&format=xls' style='height: 0px;' ></iframe>");
            }
            else {
                $window.open('/Admin/Report/PaymentConfirmation?PaymentID=' + paymentID,
                    '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
            }
        }
    }
    
    function onIssueTaxDocumentIfNeeded(paymentID) {
        paymentsSvc.issueTaxDocumentIfNeeded(paymentID);
    }

    function onPrintSalesReport() {
        salesReportParamsPromise.$promise.then(function () {            
            salesReportParamsPromise.show();
        });
    }


    $q.all([semesterSvc.getDefaultAsync()])
    .then(function (data) {
        if (data[0]) {
            $scope.semesterID = data[0].id;
        }

        if ($scope.semesterID) {
            // get invoices
            loadData();
        }

    });

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            loadData();
            $scope.selectedPayment = null;
        }
    }

    $scope.filterSummaryPaymentTypes = {
        type: 'PieChart', data: [
            ['Component', 'Value'],
            [$translate.instant('TXT_VAL_PAYMENT_TYPE_BANK_TRANSFER'), 0],
            [$translate.instant('TXT_VAL_PAYMENT_TYPE_CASH'), 0],
            [$translate.instant('TXT_VAL_PAYMENT_TYPE_CREDIT_CARD'), 0],
            [$translate.instant('TXT_VAL_PAYMENT_TYPE_BENEFIT_PLUS'), 0],
            [$translate.instant('TXT_VAL_PAYMENT_TYPE_ONLINE'), 0]
        ], options: {
            displayExactValues: true,
            chartArea: { top: '0px', left: '0px', width: '75%', height: '75%' },
            //pieSliceText: 'label',
            legend: { position: 'right' },
        }
    };

    $scope.onFilterApplied = function (filteredRows) {
        $scope.summary = paymentsSvc.calculateSummary(filteredRows);
        $timeout(function () {
            $scope.filterSummaryPaymentTypes.data[1][1] = $scope.summary.paymentTypes[0].value;
            $scope.filterSummaryPaymentTypes.data[2][1] = $scope.summary.paymentTypes[1].value;
            $scope.filterSummaryPaymentTypes.data[3][1] = $scope.summary.paymentTypes[2].value;
            $scope.filterSummaryPaymentTypes.data[4][1] = $scope.summary.paymentTypes[3].value;
            $scope.filterSummaryPaymentTypes.data[5][1] = $scope.summary.paymentTypes[4].value;
        });
    }

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "finance/payments/payments-tabs/detail.html"
    }, {
        title: 'TXT_FILTER_SUMMARY',
        template: "finance/payments/payments-tabs/filter-summary.html"
    }];

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        if (newValue !== oldValue && newValue === 1) {
            // Reset google chart to fix wrong positioning
            var orig = $scope.filterSummaryPaymentTypes.data[1][1];
                $scope.filterSummaryPaymentTypes.data[1][1] = 1;
            $timeout(function () {
                $scope.filterSummaryPaymentTypes.data[1][1] = orig;
            });
        }
        // $scope.$broadcast('activeTabChanged', { activeTab: newValue });
    });


    $scope.onRowAdd = function () {
        detailDialogPromise.$scope.paymentDetail = {
            paymentID: 0
        };

        detailDialogPromise.$promise.then(function () {
            $scope.detailError = null;
            detailDialogPromise.$scope.onSave = function (payment) {
                loadData();
                $q.all([$scope.rawPayments.$promise, $scope.terminals.$promise, $scope.accountingBooks.$promise]).then(function () {
                    if (!!payment && !!$scope.gridSettings.gridInstance) {
                        $scope.gridSettings.gridInstance.selectRows([payment.paymentID], false);
                    }
                });
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowSelected = function (data) {
        $scope.selectedPayment = data;
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$scope.paymentDetail = {
            paymentID: data.paymentID,
            invoiceForType: data.typeID,
            invoiceID: data.invoiceID,
            studentID: data.studentID,
            semesterID: data.semesterID,
            // This is wrong!! typeReferenceID for Courses And Actions should contain CourseRegistrationID
            // The same wrong code is in PaymentService.UpdateAsync
            // The problem is in wbPaymentEdit
            courseID: data.typeID !== 3 ? data.typeReferenceID : null,
            activityID: null,
            activityReconciliationID: data.typeID === 3 ? data.typeReferenceID : null,
            paymentTypeID: data.paymentTypeID,
            amount: data.value,
            selectedDate: data.paymentDate,
            notes: data.notes,
            cashReceiptNo: data.cashReceiptNo
        };

        detailDialogPromise.$promise.then(function () {
            $scope.detailError = null;
            detailDialogPromise.$scope.onSave = function (payment) {
                loadData();
                $q.all([$scope.rawPayments.$promise, $scope.terminals.$promise, $scope.accountingBooks.$promise]).then(function () {
                    if (!!payment && !!$scope.gridSettings.gridInstance) {
                        $scope.gridSettings.gridInstance.selectRows([payment.paymentID], false);
                    }
                });
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        paymentsSvc.remove(data, function () {
            preFilter();
        });
    }

    $scope.onPaymentDetailSave = function (paymentDetail) {

    }

    var detailDialogPromise = $modal({
        templateUrl: 'finance/payments/payments-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var salesReportParamsPromise = $modal({
        templateUrl: 'finance/payments/sales-report-params.html',
        show: false,
        scope: $scope.$new()
    });

}]);
